import React from 'react';
import { LateCheckoutIndicator } from '../../job-indicators';

export default function LateCheckoutBadge() {
  // We'll reuse the LateCheckoutIndicator from job-indicators.js
  return <LateCheckoutIndicator />;
} 